const LEVELS = {
    MAIN: 'main',
    SUB: 'sub',
    DETAIL: 'detail'
};

export {LEVELS};